import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from "./router";
import vuetify from './plugins/vuetify';
import VueCookies from 'vue-cookies'

import store from './store'
import Axios from "axios";
// eslint-disable-next-line no-unused-vars
import AlertSnackbar from './components/AlertSnackbar'
import moment from 'moment'
import {i18n} from './i18n'
import {Trans} from './plugins/transition'


Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
Vue.prototype.$http = Axios

Vue.prototype.moment = moment

// Development
// Vue.prototype.$http_hostname = 'http://localhost:9090/api'
Vue.prototype.$http_hostname = '/api'
Vue.prototype.$ws_hostname = null
Vue.use(Vuex)
Vue.component('Snackbar', AlertSnackbar);
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
